import React from 'react';
import {
  ClockCircleOutlined,
  PlayCircleOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  QuestionCircleOutlined,
  UserOutlined,
} from '@ant-design/icons';

const statusConfig = {
  open: {
    icon: <ClockCircleOutlined style={{ color: '#6B778C' }} />,
  },
  taken: {
    icon: <UserOutlined style={{ color: '#0052CC' }} />,
  },
  clarification: {
    icon: <QuestionCircleOutlined style={{ color: '#FF8B00' }} />,
  },
  // eslint-disable-next-line camelcase
  in_progress: {
    icon: <PlayCircleOutlined style={{ color: '#0052CC' }} />,
  },
  done: {
    icon: <CheckCircleOutlined style={{ color: '#36B37E' }} />,
  },
  closed: {
    icon: <CloseCircleOutlined style={{ color: '#DE350B' }} />,
  },
};

export default statusConfig;
